import { NgModule } from '@angular/core';

import { RtUIModule } from '@recruitee/user-interface';

import {
  AdminsSelectDialogComponent,
  AdminsSelectDialogData,
} from '../dialogs/admins-select-dialog/admins-select-dialog.component';

@NgModule({
  imports: [RtUIModule],
  declarations: [AdminsSelectDialogComponent],
  exports: [AdminsSelectDialogComponent],
})
export class RtAdminSelectSharedModule {}

export { AdminsSelectDialogComponent, AdminsSelectDialogData };
